import { React, useState, useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import "./UploadFiles.css";
import flag from "../../images/indian-flag.jpg";
import { uploadImage } from "../../services/Api";
import { useSearchParams , useNavigate } from "react-router-dom";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";

const fileTypes = ["JPEG", "PNG", "JPG"];

const UploadFiles = (props) => {
  
  const navigate = useNavigate();
  const initial = {
    uid: "",
    name: "",
    usertype: "",
  }
  const [user , setUser] = useState(initial);
  const toast = useToast();
  console.log(props);
  const name = props.name;
  const eventid = props.eventid;
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [success , setSuccess] = useState(false);
  
  useEffect(() => {
    const data = JSON.parse(window.localStorage.getItem("user"));
    console.log(data);
    if (data) setUser(data);
  }, [])
  
  
  const handleChange = (files) => {
    console.log(files);
    setFiles(files);
    // setSelectedFile(URL.createObjectURL(file[0]));
    // if (selectedFile) console.log(selectedFile);
    // console.log(Object.values(file));
    console.log(files);
  };
  const [click , setClick] = useState(true);
  const handleUpload = async (e) => {
    // e.target.setAttribute("disabled", true);
    setClick(false);
    try {
      const data = await uploadImage({files , eventid});
      console.log(data);
      const btn = document.getElementsByClassName("upload-btn")
      if(data.data.status === "success") {
        setSuccess(true);
        toast({
          title: "File Upload",
          description: `${data.data.message}`,
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        btn.disabled = false;
        navigate("/events");
        // window.location.reload();
      } else {
        toast({
          title: "File Upload",
          description: `${data.data.message}`,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "File Upload",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    setClick(true);
  }
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      
      {
        user?.uid ?
          <Button colorScheme="blue" onClick={onOpen} style={{ margin: "1rem" }}>
            Upload Image
          </Button>
        : 
          <Button disabled onClick={onOpen} style={{ margin: "1rem" }}>
            Upload Image
          </Button>
      }

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Upload Image for {name}</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <div className="upload-files-container">
            <FileUploader
              multiple={true}
              handleChange={handleChange}
              name="file"
              types={fileTypes}
            />
            <p className="file-names">
              {files.length
                ? `File names : ${Object.values(files).map(
                    (el) => el.name + " "
                  )}`
                : "no files uploaded yet"}
            </p>
            {
              click ? 
                <Button className="upload-btn" colorScheme="teal" mr={3} onClick={(e) => handleUpload(e)}>
                  Upload
                </Button>
              :
                <Button disabled className="upload-btn" colorScheme="teal" mr={3} onClick={(e) => handleUpload(e)}>
                  Upload
                </Button>
            }
          </div>
          <ModalFooter style={{ padding: "2rem" }}>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UploadFiles
